import { createApiAction, restApiActions } from 'redux/redux-actions';
import restApis from 'redux/restApis';
import { GET_SHOP, SHOP_HAS_DELIVERY_FEE_ORDER } from 'redux/constants';

// const getShopPublicApi = restApis('shop/public').read;
// const getShopApi = restApis('shop').read;
const shopDeliveryFeeOrderApi = restApis('shop/has-delivery-fee-order');

export const shopActions = restApiActions('shop');
export const shopItemsActions = restApiActions('shop', 'items');
export const shopOrdersActions = restApiActions('shop', 'orders');
// export const getShopPublic = createApiAction(GET_SHOP, getShopPublicApi);
// export const getShop = createApiAction(GET_SHOP, getShopApi);
export const shopHasDeliveryFeeOrder =
  createApiAction(SHOP_HAS_DELIVERY_FEE_ORDER, shopDeliveryFeeOrderApi.list);

export default restApiActions('shop');
